import { createAction } from "@reduxjs/toolkit";

import { RootState } from "@/store";
import { RequestQueueItem } from "@/types/requestQueue";

export interface RestoreProgressFromServer {
    progress: RootState["progress"];
    requestQueue: RequestQueueItem[];
}

export type RestoreConfigFromServer = RootState["config"];

export const logoutResetApp = createAction("app/logoutReset");

export const safeReset = createAction("app/safeReset");

export const fullReset = createAction("app/fullReset");

export const restoreProgressFromServer =
    createAction<RestoreProgressFromServer>("state/restoreProgressFromServer");

export const restoreConfigFromServer = createAction<RestoreConfigFromServer>(
    "state/restoreConfigFromServer",
);
